import {Component, OnInit, Input, Output, EventEmitter} from '@angular/core'

@Component({
  selector: 'dmmp-paginator',
  templateUrl: './paginator.component.html'
})
export class PaginatorComponent implements OnInit {

  @Input() currentPage
  @Input() totalPages
  @Input() loop = false
  @Input() paginatorType
  @Output() newPageEmitter: EventEmitter<any> = new EventEmitter()

  constructor() {
  }

  ngOnInit(): void {
  }

  nextPage() {
    if (this.loop && (this.totalPages < this.currentPage + 1)) {
      this.newPageEmitter.emit({number: 1, direction: 'next'})
    } else {
      this.newPageEmitter.emit({number: this.currentPage + 1, direction: 'next'})
    }
  }

  previousPage() {
    if (this.loop && (this.currentPage - 1) === 0) {
      this.newPageEmitter.emit({number: this.totalPages, direction: 'prev'})
    } else {
      this.newPageEmitter.emit({number: this.currentPage - 1, direction: 'prev'})
    }
  }

}
